export const ohlcEndpoint = '/Chart/GetOhlcForChartApp';
export const ohlcRangeEndpoint = '/Chart/GetOhlcDataRangeForChartApp';
export const studyDataRangeUrl = "/Chart/GetStudyDataRangeForChartApp";

export const chartConfig = {
    priceDataId: 'price_data',
    xAxisName: 'x-axis',
    yAxisName: 'y-axis',
    studyAxisName: 'study-axis',
    autoChangeLineColor: true,
    extendTimeUnitInFuture: 33
};

export const whiteColor = 'white';
export const greenColor = '#00F900';
export const purpleColor = '#F808F2';
export const redColor = 'red';